import { IProducts } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductEmblaSlider from "./ProductEmblaSlider";
import ProductBox from "../product-box/ProductBox";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
interface Props {
  products: IProducts;
  setIslastProduct?: (isLastProduct: boolean) => void;
  scrollableTabs?: boolean;
  theme: ITheme;
  showCustomEventData?: boolean;
}
const ProductCarousel: React.FC<Props> = ({
  products,
  setIslastProduct,
  scrollableTabs,
  theme,
  showCustomEventData,
}) => {
  return (
    <ProductEmblaSlider products={products} setIslastProduct={setIslastProduct}>
      {products?.data.map((single, key) => (
        <ProductBox
          isGrid={false}
          theme={theme}
          key={key}
          size={products.configurations?.style_type!}
          {...single}
          scrollableTabs={scrollableTabs!}
          priority={key < 0}
          Customize={products?.configurations?.customize}
          showCustomEventData={showCustomEventData}
        />
      ))}
    </ProductEmblaSlider>
  );
};

export default ProductCarousel;
